import Button from "lib/components/atomic/Button";
import { ArrowBoardVector } from "lib/components/atomic/Vectors";
import RightarrowIcon from "lib/components/Icon/RightarrowIcon";
import React from "react";
import Link from "next/link";

interface Props {
  className?: string;
  title: string;
  description: string;
  vector: React.ReactNode;
  buttonText: string;
  link: string;
}

const BannerCard = ({
  className,
  title,
  description,
  vector,
  buttonText,
  link,
}: Props) => {
  return (
    <div
      className={`bg-primary-100 rounded-10 flex ${className ? className : ""}`}
    >
      <div className="py-8 pl-8">
        <h4 className="font-bold text-xl ">{title}</h4>

        <p className="text-gray text-base " style={{ maxWidth: "300px" }}>
          {description}
        </p>
        <Link href={link}>
          {/* @next-codemod-error This Link previously used the now removed `legacyBehavior` prop, and has a child that might not be an anchor. The codemod bailed out of lifting the child props to the Link. Check that the child component does not render an anchor, and potentially move the props manually to Link. */
          }
          <p className="text-info bg-transparent flex items-center gap-2 cursor-pointer hover:text-info-500">
            {buttonText}
            <RightarrowIcon />
          </p>
        </Link>
      </div>
      <div className="flex-1 h-[266px] w-[300px] flex justify-end">
        {vector}
      </div>
    </div>
  );
};

export default BannerCard;
